import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './services/auth/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./services/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
  },
  {
    path: 'branches',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/branches/branches.module').then(m => m.BranchesModule)
  },
  {
    path: 'companies',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/companies/companies.module').then(m => m.CompaniesModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgotPassword/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/resetPassword/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'licensing',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/licensing/licensing.module').then(m => m.LicensingModule)
  },
  { path: '**', redirectTo: 'auth' }, // 404 handling
    {
  path: 'credit-debit-notes',
  loadChildren: () => import('./pages/credit-debit-notes/credit-debit-notes.module').then(m => m.CreditDebitNotesModule),
},
 {
        path: 'debit-vendor',
        loadChildren: () => import('./pages/debit-vendor/debit-vendor-details.module')
          .then(m => m.DebitVendorDetailsModule)
      },
        {
        path: 'credit-vendor',
        loadChildren: () => import('./pages/credit-vendor/credit-vendor.module')
          .then(m => m.CreditVendorModule)
      },

      {
      path: 'general-ledger',
      loadChildren: () =>
       import('./pages/add-general-leadure/add-general-leadure.module')
      .then(m => m.AddGeneralLeadureModule),
      },

      {
      path: 'gl-assignment',
      loadChildren: () =>
       import('./pages/gl-assignment/gl-assignment.module')
      .then(m => m.GlAssignmentModule),
      },

      {
          path: 'time',
          loadChildren: () => import('./pages/time/time.module').then(m => m.TimeModule)
           },



  // Nebular auth routes
  // {
  //   path: 'auth',
  //   component: NbAuthComponent,
  //   children: [
  //     { path: '', component: NbLoginComponent },
  //    // { path: 'login', component: NbLoginComponent },
  //     { path: 'register', component: NbRegisterComponent },
  //     { path: 'logout', component: NbLogoutComponent },
  //     { path: 'request-password', component: NbRequestPasswordComponent },
  //     { path: 'reset-password', component: NbResetPasswordComponent },
  //   ],
  // },

  // Wildcard route (should be last)
  { path: '**', redirectTo: '/login' }
];

const config: ExtraOptions = {
  useHash: true, // Changed to true to help with routing issues
  onSameUrlNavigation: 'reload', // Added to handle navigation to the same URL
  enableTracing: false, // Set to true temporarily for debugging routing issues
  scrollPositionRestoration: 'enabled', // Improves user experience
  paramsInheritanceStrategy: 'always', // Can help with nested routes
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
